import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Chips } from "primereact/chips";
import { emailPattern, EMAIL_RECIPIENTS_LIMIT } from "../../constants";
import { Alert } from "../../common/Alert";
import LoadingIndicator from "../LoadingIndicator";
import MESSAGES from "../../constants/Messages";
import { useTranslation } from "react-i18next";
import { addError, pushPageData } from "../../utils/analytics";
import { MILESTONES } from "../../constants";
import { saveAWBNotificationSubscription } from "../../services/userProfileService";
import getCurrentUser from "../../utils/getCurrentUser";
import { object } from "prop-types";
import closeIcon from "../../assets/images/close.png";
import backIcon from "../../assets/images/chevron-left.svg";
import "./notificationDialog.scss";

const MilestoneNotificationDialog = ({
  awbNumber,
  displayBasic,
  setDisplayBasic,
  storedMilestones,
  setStoredMilestones,
}) => {
  const getMileStoneDataInitialValue = () => {
    const loggedInUserProfile = getCurrentUser();
    return {
      agentCode: loggedInUserProfile?.agentCode,
      awbNumber: "",
      userId: loggedInUserProfile?.userId,
      email: loggedInUserProfile?.email ? [loggedInUserProfile.email] : [],
      status: true,
      station: loggedInUserProfile?.defaultAirportCode,
      accepted: true,
      departed: true,
      arrived: true,
      notified: true,
      delivered: true,
    };
  };

  //for multilingual
  const { t, i18n } = useTranslation(["labels", "errors"]);

  const [emailInvalid, setEmailInvalid] = useState("");
  const [error, setError] = useState(null);
  const [allCheckBox, setAllCheckBox] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [sentSuccess, setSentSuccess] = useState(false);
  const [milesStoneData, setMilesStoneData] = useState(
    getMileStoneDataInitialValue()
  );
  const milestoneTypeArry = [
    "accepted",
    "departed",
    "arrived",
    "notified",
    "delivered",
  ];

  const handleChangeMilestone = (event, type) => {
    const isChecked = event?.target?.checked;

    setMilesStoneData((prev) => {
      const updatedMileStones = { ...prev, [type]: isChecked };
      const requiredMilestones = [
        "accepted",
        "arrived",
        "delivered",
        "departed",
        "notified",
      ];

      const allChecked = requiredMilestones.every(
        (milestone) => updatedMileStones?.[milestone] === true
      );
      setAllCheckBox(allChecked);

      return updatedMileStones;
    });
  };

  const handleAllCheck = (event) => {
    const isChecked = event?.target?.checked;
    setAllCheckBox(isChecked);

    setMilesStoneData((prev) => {
      const updatedMileStones = { ...prev };
      const requiredMilestones = [
        "accepted",
        "arrived",
        "delivered",
        "departed",
        "notified",
      ];

      requiredMilestones.forEach((milestone) => {
        updatedMileStones[milestone] = isChecked;
      });

      return updatedMileStones;
    });
  };

  useEffect(() => {
    if (allCheckBox) {
      setMilesStoneData((prev) => {
        const updatedMileStones = { ...prev };
        milestoneTypeArry.forEach((milestone) => {
          updatedMileStones[milestone] = true;
        });
        return updatedMileStones;
      });
    }
  }, [allCheckBox]);

  const handleSaveSubscription = async () => {
    if (milesStoneData.email && milesStoneData.email.length > 0) {
      setIsLoading(true);
      onHide();
      await saveAWBNotificationSubscription({
        ...milesStoneData,
        email: milesStoneData.email.join(","),
        awbNumber: awbNumber?.trim()?.replace(" ", "-"),
      })
        .then((response) => {
          setIsLoading(false);
          if (response && response?.status === "F") {
            setAlertMessage(t(MESSAGES.USER_PROFILE_SAVE_NOTIFICATION_FAILED));
            setSentSuccess(false);
          } else if (response && response?.status === "S") {
            setAlertMessage("Notification subscription saved successfully");
            setSentSuccess(true);
          }
          window.scrollTo(0, 0);
          return response;
        })
        .catch((error) => {
          setIsLoading(false);
          setAlertMessage(t(MESSAGES.USER_PROFILE_SAVE_NOTIFICATION_FAILED));
          setSentSuccess(false);
          window.scrollTo(0, 0);
          return null;
        });
    } else {
      setError(
        t(MESSAGES.INCORRECT_MAIL_ENTERED, {
          val: emailInvalid,
          ns: "errors",
        })
      );
      addError(
        MESSAGES.INCORRECT_MAIL_ENTERED,
        i18n.getResource("en", "errors", MESSAGES.INCORRECT_MAIL_ENTERED)
      );
    }
  };

  const onHide = () => {
    if (setStoredMilestones) {
      setStoredMilestones(milesStoneData);
    }
    setDisplayBasic(false);
    setError(null);
    setAlertMessage("");
    setSentSuccess(false);
  };

  const onChange = (e) => {
    const updatedEmails = e.value;
    const invalidEmails = updatedEmails.filter(
      (email) => !emailPattern.test(email)
    );

    if (invalidEmails.length > 0) {
      setError(
        t(MESSAGES.INCORRECT_MAIL_ENTERED, {
          val: invalidEmails[0],
          ns: "errors",
        })
      );
    } else {
      setError(null);
      setMilesStoneData((prev) => ({
        ...prev,
        email: updatedEmails,
      }));
    }
  };

  // const onChange = (e) => {
  // 	const updatedEmails = e.value;
  // 	console.log('updatedEmails', updatedEmails);
  // 	const lastVal = updatedEmails[updatedEmails.length - 1];

  // 	if (lastVal && !emailPattern.test(lastVal)) {
  // 		setError(
  // 			t(MESSAGES.INCORRECT_MAIL_ENTERED, {
  // 				val: lastVal,
  // 				ns: 'errors',
  // 			})
  // 		);
  // 		setTimeout(() => {
  // 			setError(null);
  // 		}, 5000);
  // 	} else {
  // 		setError(null);
  // 		setMilesStoneData(prev => ({
  // 			...prev,
  // 			email: updatedEmails
  // 		}));
  // 	}
  // };

  // const onChange = (e) => {
  // 	const value = e.value.toString().trim()
  // 	console.log('value', value);
  // 	let lastVal = ''
  // 	if (value && value.indexOf(',') === -1) {
  // 		lastVal = value
  // 	} else {
  // 		let values = value.split(',')
  // 		lastVal = values[values.length - 1]
  // 	}
  // 	if (!emailPattern.test(lastVal)) {
  // 		setError(
  // 			t(MESSAGES.INCORRECT_MAIL_ENTERED, {
  // 				val: lastVal,
  // 				ns: 'errors',
  // 			})
  // 		)
  // 		setTimeout(() => {
  // 			setError(null)
  // 		}, 5000)
  // 	} else {
  // 		setError(null)
  // 		setMilesStoneData(prev => ({ ...prev, email: [...prev.email, value] }))
  // 	}
  // }

  const handleAlertClose = () => {
    setAlertMessage("");
    setSentSuccess(false);
  };

  const onBlur = (e) => {
    const input = e.target.value?.trim();
    if (input) {
      const splitValues = input
        .split(",")
        .map((i) => i.trim())
        .filter(Boolean);

      let invalid = splitValues.find((val) => !emailPattern.test(val));
      if (invalid) {
        setEmailInvalid(invalid);
        setError(
          t(MESSAGES.INCORRECT_MAIL_ENTERED, {
            val: invalid,
            ns: "errors",
          })
        );
        return;
      }

      setEmailInvalid("");
      setError(null);

      setMilesStoneData((prev) => {
        const existingEmails = Array.isArray(prev.email) ? prev.email : [];
        const newEmails = splitValues.filter(
          (email) => !existingEmails.includes(email)
        );
        return {
          ...prev,
          email: [...existingEmails, ...newEmails],
        };
      });

      e.target.value = "";
    }
  };

  const onFocus = (e) => {
    setError(null);
    e.target.value = "";
  };

  const onRemove = (e) => {
    const updatedEmails = milesStoneData?.email.filter(
      (mail) => mail !== e.value.toString()
    );
    setMilesStoneData((prev) => ({ ...prev, email: updatedEmails }));
    if (updatedEmails.length === 0) {
      setError(null);
    }
  };

  useEffect(() => {
    if (displayBasic) {
      if (storedMilestones) {
        const normalizedEmails = Array.isArray(storedMilestones.email)
          ? storedMilestones.email
          : typeof storedMilestones.email === "string"
          ? storedMilestones.email
              .split(",")
              .map((e) => e.trim())
              .filter(Boolean)
          : [];

        setMilesStoneData((prev) => ({
          ...prev,
          ...storedMilestones,
          email: normalizedEmails,
        }));

        const requiredMilestones = [
          "accepted",
          "arrived",
          "delivered",
          "departed",
          "notified",
        ];
        const allChecked = requiredMilestones.every(
          (milestone) => storedMilestones?.[milestone] === true
        );

        setAllCheckBox(allChecked);
      } else {
        setAllCheckBox(true);
      }
    }
  }, [displayBasic]);

  return (
    <div className="cargo-portal-container dialog-container">
      {alertMessage !== "" && (
        <Alert
          isError={!sentSuccess}
          showAlert={true}
          message={alertMessage}
          onAlertClose={handleAlertClose}
          setTimeout={true}
        />
      )}
      {isLoading ? <LoadingIndicator /> : <></>}
      <div className="portal-dialog p-fluid">
        {displayBasic && (
          <div className="notification-container">
            <div className=" header-close-container d-none d-lg-flex">
              <div className="hedaer-text-area">
                <div className="print-details-header">
                  {" "}
                  {t("COMMON.NOTIFICATIONS")}
                </div>
                <div className="select-option-text">
                  {t("COMMON.SELECT_MILESTONES")}
                </div>
              </div>

              <button className="close-button">
                <img src={closeIcon} alt="close" onClick={onHide}></img>
              </button>
            </div>

            <div className="d-flex d-lg-none header-close-container-mobile-notification">
              <div className="close-header-mobile">
                <div className="header-text-mobile d-flex align-items-center">
                  <img
                    src={backIcon}
                    alt="Share"
                    className="share-print-icon"
                    onClick={onHide}
                  />
                  <div className="label-back">Back</div>
                </div>
                <div className="sub-text-mobile">
                  <div className="share-booking-details-header-mobile">
                    {t("COMMON.NOTIFICATIONS")}
                  </div>
                  <p className="enter-email-header-moble mb-0">
                    {t("COMMON.SELECT_MILESTONES")}
                  </p>
                </div>
              </div>
            </div>

            <div className="enter-email-wrapper d-none d-lg-flex">
              <div className="milestone-middle-wrapper">
                <div className="milestone-text-checkbox-container">
                  <div className="milestone-text">
                    {" "}
                    {t("COMMON.MILESTONES")}
                  </div>
                  <div className="d-flex check-box-container">
                    <div className="l-checkbox">
                      <input
                        id="milestone1"
                        checked={allCheckBox}
                        value="All"
                        type="checkbox"
                        name="milestone1"
                        onChange={handleAllCheck}
                        // type="checkbox"
                        //           checked={milestones.all}
                        //           onChange={handleCheckboxChange}
                        //           id="all"
                        //           name="all"
                      />
                      <label className="mb-0" htmlFor="milestone1">
                        {t("COMMON.ALL")}
                      </label>
                    </div>

                    <div className="l-checkbox">
                      <input
                        id="milestone2"
                        checked={milesStoneData?.accepted}
                        value="Accepted"
                        type="checkbox"
                        name="milestone2"
                        onChange={(e) => handleChangeMilestone(e, "accepted")}
                      />
                      <label className="mb-0" htmlFor="milestone2">
                        {t("COMMON.ACCEPTED")}
                      </label>
                    </div>

                    <div className="l-checkbox">
                      <input
                        id="milestone3"
                        checked={milesStoneData?.departed}
                        value="Departed"
                        type="checkbox"
                        name="milestone3"
                        onChange={(e) => handleChangeMilestone(e, "departed")}
                      />
                      <label className="mb-0" htmlFor="milestone3">
                        {t("COMMON.DEPARTED")}
                      </label>
                    </div>
                    <div className="l-checkbox">
                      <input
                        id="milestone4"
                        checked={milesStoneData?.arrived}
                        value="Arrived"
                        type="checkbox"
                        name="milestone4"
                        onChange={(e) => handleChangeMilestone(e, "arrived")}
                      />
                      <label className="mb-0" htmlFor="milestone4">
                        {t("COMMON.ARRIVED")}
                      </label>
                    </div>

                    <div className="l-checkbox">
                      <input
                        id="milestone5"
                        checked={milesStoneData?.notified}
                        value="Notified"
                        type="checkbox"
                        name="milestone5"
                        className="form-item__field"
                        onChange={(e) => handleChangeMilestone(e, "notified")}
                      />
                      <label className="mb-0" htmlFor="milestone5">
                        {t("COMMON.NOTIFIED")}
                      </label>
                    </div>

                    <div className="l-checkbox">
                      <input
                        id="milestone6"
                        checked={milesStoneData?.delivered}
                        value="Delivered"
                        type="checkbox"
                        name="milestone6"
                        onChange={(e) => handleChangeMilestone(e, "delivered")}
                      />
                      <label className="mb-0" htmlFor="milestone6">
                        {t("COMMON.DELIVERED")}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="enter-email-wrapper-notification">
                  <div className="comma-info-text">
                    {t(MESSAGES.POP_UP_TEXT_BOX_INFO, { ns: "errors" })}
                  </div>
                  <div>
                    <Chips
                      // value={email}
                      // onChange={onChange}
                      // separator=","
                      className="custom-chips-input"
                      // className={`custom-chips-input ${error ? "error" : ""}`}
                      //     className="custom-chips-input"
                      placeholder="Enter email address"
                      // allowDuplicate={false}
                      // max={EMAIL_RECIPIENTS_LIMIT}
                      // onBlur={onBlur}
                      // onFocus={onFocus}
                      // onRemove={onRemove}
                      value={milesStoneData?.email}
                      onChange={onChange}
                      separator=","
                      // className='email-ids'
                      allowDuplicate={false}
                      max={EMAIL_RECIPIENTS_LIMIT}
                      onBlur={onBlur}
                      onFocus={onFocus}
                      onRemove={onRemove}
                    />
                    <span className="form-item__error">
                      {/* {error ? error : ""} */}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="enter-email-wrapper d-flex d-lg-none">
              <div className="milestone-middle-wrapper">
                <div>
                  <div className="milestone-text">
                    {" "}
                    {t("COMMON.MILESTONES")}
                  </div>

                  <div className="d-flex check-box-container">
                    <div className="l-checkbox same-width">
                      <input
                        // type="checkbox"
                        //           checked={milestones.all}
                        //           onChange={handleCheckboxChange}
                        //           id="all"
                        //           name="all"
                        id="milestone1"
                        checked={allCheckBox}
                        value="All"
                        type="checkbox"
                        name="milestone1"
                        onChange={handleAllCheck}
                      />
                      <label className="mb-0" htmlFor="milestone1">
                        {t("COMMON.ALL")}
                      </label>
                    </div>

                    <div className="l-checkbox same-width">
                      <input
                        id="milestone2"
                        checked={milesStoneData?.accepted}
                        value="Accepted"
                        type="checkbox"
                        name="milestone2"
                        onChange={(e) => handleChangeMilestone(e, "accepted")}
                      />
                      <label className="mb-0" htmlFor="milestone2">
                        {t("COMMON.ACCEPTED")}
                      </label>
                    </div>

                    <div className="l-checkbox same-width">
                      <input
                        id="milestone3"
                        checked={milesStoneData?.departed}
                        value="Departed"
                        type="checkbox"
                        name="milestone3"
                        className="form-item__field"
                        onChange={(e) => handleChangeMilestone(e, "departed")}
                      />
                      <label className="mb-0" htmlFor="milestone3">
                        {t("COMMON.DEPARTED")}
                      </label>
                    </div>
                    {/* <div
                      className="form-item form-item--checkbox same-width"
                      data-module="molecules/form-item/FormItem"
                    >
                      <input
                        type="checkbox"
                        className="form-item__field"
                        checked={milestones.all}
                        onChange={handleCheckboxChange}
                        id="all"
                        name="all"
                      />
                      <label
                        htmlFor="all"
                        className="form-item__label label-text include-charge-text"
                      >
                        All
                      </label>
                    </div>
                    <div
                      className="form-item form-item--checkbox same-width"
                      data-module="molecules/form-item/FormItem"
                    >
                      <input
                        type="checkbox"
                        className="form-item__field"
                        id="accepted"
                        name="accepted"
                        checked={milestones.accepted}
                        onChange={handleCheckboxChange}
                      />
                      <label
                        className="form-item__label label-text include-charge-text"
                        htmlFor="accepted"
                      >
                        Accepted
                      </label>
                    </div>
                    <div
                      className="form-item form-item--checkbox same-width"
                      data-module="molecules/form-item/FormItem"
                    >
                      <input
                        type="checkbox"
                        className="form-item__field"
                        id="departed"
                        name="departed"
                        checked={milestones.departed}
                        onChange={handleCheckboxChange}
                      />
                      <label
                        className="form-item__label label-text include-charge-text"
                        htmlFor="departed"
                      >
                        Departed
                      </label>
                    </div> */}
                  </div>

                  <div className="d-flex">
                    <div className="l-checkbox same-width">
                      <input
                        id="milestone4"
                        checked={milesStoneData?.arrived}
                        value="Arrived"
                        type="checkbox"
                        name="milestone4"
                        onChange={(e) => handleChangeMilestone(e, "arrived")}
                      />
                      <label className="mb-0" htmlFor="milestone4">
                        {t("COMMON.ARRIVED")}
                      </label>
                    </div>

                    <div className="l-checkbox same-width">
                      <input
                        id="milestone5"
                        checked={milesStoneData?.notified}
                        value="Notified"
                        type="checkbox"
                        name="milestone5"
                        onChange={(e) => handleChangeMilestone(e, "notified")}
                      />
                      <label className="mb-0" htmlFor="milestone5">
                        {t("COMMON.NOTIFIED")}
                      </label>
                    </div>

                    <div className="l-checkbox same-width">
                      <input
                        id="milestone6"
                        checked={milesStoneData?.delivered}
                        value="Delivered"
                        type="checkbox"
                        name="milestone6"
                        onChange={(e) => handleChangeMilestone(e, "delivered")}
                      />
                      <label className="mb-0" htmlFor="milestone6">
                        {t("COMMON.DELIVERED")}
                      </label>
                    </div>
                    {/* <div
                      className="form-item form-item--checkbox arrived-checkbox same-width"
                      data-module="molecules/form-item/FormItem"
                    >
                      <input
                        type="checkbox"
                        className="form-item__field"
                        id="arrived"
                        name="arrived"
                        checked={milestones.arrived}
                        onChange={handleCheckboxChange}
                      />
                      <label
                        className="form-item__label label-text include-charge-text"
                        htmlFor="arrived"
                      >
                        Arrived
                      </label>
                    </div>

                    <div
                      className="form-item form-item--checkbox same-width"
                      data-module="molecules/form-item/FormItem"
                    >
                      <input
                        type="checkbox"
                        className="form-item__field"
                        id="notified"
                        name="notified"
                        checked={milestones.notified}
                        onChange={handleCheckboxChange}
                      />
                      <label
                        className="form-item__label label-text include-charge-text"
                        htmlFor="notified"
                      >
                        Notified
                      </label>
                    </div>

                    <div
                      className="form-item form-item--checkbox same-width"
                      data-module="molecules/form-item/FormItem"
                    >
                      <input
                        type="checkbox"
                        className="form-item__field"
                        id="delivered"
                        name="delivered"
                        checked={milestones.delivered}
                        onChange={handleCheckboxChange}
                      />
                      <label
                        className="form-item__label label-text include-charge-text"
                        htmlFor="delivered"
                      >
                        Delivered
                      </label>
                    </div> */}
                  </div>
                </div>
                <div className="enter-email-wrapper-notification">
                  <div className="comma-info-text">
                    For multiple email addresses, please enter comma between
                    each address
                  </div>
                  <div>
                    <Chips
                      value={milesStoneData?.email}
                      onChange={onChange}
                      separator=","
                      // className='email-ids'
                      allowDuplicate={false}
                      max={EMAIL_RECIPIENTS_LIMIT}
                      onBlur={onBlur}
                      onFocus={onFocus}
                      onRemove={onRemove}
                      // value={email}
                      // onChange={onChange}
                      // separator=","
                      className="custom-chips-input"
                      // className={`custom-chips-input ${error ? "error" : ""}`}
                      //     className="custom-chips-input"
                      placeholder="Enter email address"
                      // allowDuplicate={false}
                      // max={EMAIL_RECIPIENTS_LIMIT}
                      // onBlur={onBlur}
                      // onFocus={onFocus}
                      // onRemove={onRemove}
                    />
                    <span className="form-item__error">
                      {/* {error ? error : ""} */}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer-wrapper">
              <button
                type="button"
                className="primary-button subscribe-buttom"
                onClick={handleSaveSubscription}
              >
                {t("COMMON.SUBSCRIBE")}
              </button>
            </div>
          </div>
        )}
        {/* <Dialog
					header=''
					visible={displayBasic}
					className='dialogWrapper'
					onHide={onHide}
				>
					<div>
						<h3 className='mt-1 mb-3'>Subscribe for notifications</h3>
						<p>Select the milestones to be notified and enter the email addresses.</p>
						<div className='form-row notify_list mt-4 mb-1'>
							<div className='col-12 col-lg-auto'>
								<label className='text-left'>Milestones</label>
							</div>
						</div>
						<div className='form-row notify_list mt-1 mb-4'>
							<div className='col-12 col-lg-auto'>
								<div
									className='form-item form-item--checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='milestone1'
										checked={allCheckBox}
										value='All'
										type='checkbox'
										name='milestone1'
										className='form-item__field'
										onChange={handleAllCheck}
									/>
									<label
										htmlFor='milestone1'
										className='form-item__label'
									>
										{t('COMMON.ALL')}
									</label>
								</div>
							</div>
							<div className='col-12 col-lg-auto'>
								<div
									className='form-item form-item--checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='milestone2'
										checked={milesStoneData?.accepted}
										value='Accepted'
										type='checkbox'
										name='milestone2'
										className='form-item__field'
										onChange={(e) => handleChangeMilestone(e, 'accepted')}
									/>
									<label
										htmlFor='milestone2'
										className='form-item__label'
									>
										{t('COMMON.ACCEPTED')}
									</label>
								</div>
							</div>
							<div className='col-12 col-lg-auto'>
								<div
									className='form-item form-item--checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='milestone3'
										checked={milesStoneData?.departed}
										value='Departed'
										type='checkbox'
										name='milestone3'
										className='form-item__field'
										onChange={(e) => handleChangeMilestone(e, 'departed')}
									/>
									<label
										htmlFor='milestone3'
										className='form-item__label'
									>
										{t('COMMON.DEPARTED')}
									</label>
								</div>
							</div>
							<div className='col-12 col-lg-auto'>
								<div
									className='form-item form-item--checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='milestone4'
										checked={milesStoneData?.arrived}
										value='Arrived'
										type='checkbox'
										name='milestone4'
										className='form-item__field'
										onChange={(e) => handleChangeMilestone(e, 'arrived')}
									/>
									<label
										htmlFor='milestone4'
										className='form-item__label'
									>
										{t('COMMON.ARRIVED')}
									</label>
								</div>
							</div>
							<div className='col-12 col-lg-auto'>
								<div
									className='form-item form-item--checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='milestone5'
										checked={milesStoneData?.notified}
										value='Notified'
										type='checkbox'
										name='milestone5'
										className='form-item__field'
										onChange={(e) => handleChangeMilestone(e, 'notified')}
									/>
									<label
										htmlFor='milestone5'
										className='form-item__label'
									>
										{t('COMMON.NOTIFIED')}
									</label>
								</div>
							</div>
							<div className='col-12 col-lg-auto'>
								<div
									className='form-item form-item--checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='milestone6'
										checked={milesStoneData?.delivered}
										value='Delivered'
										type='checkbox'
										name='milestone6'
										className='form-item__field'
										onChange={(e) => handleChangeMilestone(e, 'delivered')}
									/>
									<label
										htmlFor='milestone6'
										className='form-item__label'
									>
										{t('COMMON.DELIVERED')}
									</label>
								</div>
							</div>
						</div>
						<label className='align-left text-left'>
							<span className='input-info text-left'>
								{t(MESSAGES.POP_UP_TEXT_BOX_INFO, { ns: 'errors' })}
							</span>
						</label>
						<Chips
							value={milesStoneData?.email}
							onChange={onChange}
							separator=','
							className='email-ids'
							allowDuplicate={false}
							max={EMAIL_RECIPIENTS_LIMIT}
							onBlur={onBlur}
							onFocus={onFocus}
							onRemove={onRemove}
						/>
						<span className='form-item__error'>{error ? error : ''}</span>
						<div className='form-row mt-4 mb-2'>
							<div className='col-12 align-center'>
								<button onClick={handleSaveSubscription} className='primary-button mr-0'>
									{t('COMMON.SAVE')}
								</button>
							</div>
						</div>
					</div>
				</Dialog> */}
      </div>
    </div>
  );
};

export default MilestoneNotificationDialog;
